module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Chapter T"), _c('span', {
    staticClass: "CN_BOLD"
  }, [_vm._v("wo")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "CIT"
  }, [_c('span', {
    staticClass: "FIRSTLINE_CIT"
  }, [_vm._v("THE NEXT MORNING MY FIRST-PERIOD")]), _vm._v(" TA job rolls around, and I go straight to Mr. Bealles, our librarian.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He glances up from the circulation desk. “Hey, Slim.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s always odd to me when teachers call me by my nickname. “Anything for me to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He nods his bald head to the left. “Just shelve those books.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Quickly I do and then head straight to my usual computer station. As I’m logging on, my best friend, Reggie, texts me. "), _c('span', {
    staticClass: "TX-SC"
  }, [_vm._v("CAN U TALK?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I dial her number. “What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You doing okay today?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("No, but of course I don’t say this. “Yeah, Reg. All good.”")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("“Mm-hmm.”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("She knows I’m lying.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“All right,” she says, “but the last few times we’ve talked you’ve been even more "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("short and sweet")]), _vm._v(" than usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Because everyone’s in my business, and I’m about to erupt if I don’t figure out my shit. “Listen, I’ve got to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Lane . . . I miss your mom too. You barely talk about her. I worry that you’re not dealing with things.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m dealing,” I reassure her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She sighs. “Well, I’m barely dealing. And I wasn’t even her daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I pause. Sometimes I forget how close Reggie and my mom were.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Just know . . . know that you can "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("talk to me")]), _vm._v(",” she emphasizes. “About anything. Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My heart softens. Reggie really is a good friend. But what am I supposed to say? That I decapitated my mother like she had done to so many others? That the loving woman Reggie mourns was a monster?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Okay, Reg,” I say instead. “Thanks for being you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I feel her smile through the phone. “Love you, girl. I’ll bug you later.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This makes me chuckle. Just a little.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m sorry. Was that a "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("laugh")]), _vm._v(" I just heard?”")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("“Bye, Reg.” I click off and spend the next ten minutes ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("researching Jacks and Aisha, although I don’t discover anything new.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hey, you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I glance up. "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("Zach")]), _vm._v(". My ex-boyfriend. Sort of. Our relationship is so much more complicated than that. We’ve done a good job of politely acknowledging each other over the past months. It’s not like we can avoid the other, going to the same school and all. But actually exchanging words? This is a first.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And just the sight of him standing in all his tall, lean, dark-haired cuteness makes me genuinely smile. “Hey.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The terrifying image of him in my mother’s kill room flashes across my brain, and I shove it away. I can’t think about that. I won’t.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His brows twitch like he just picked up on my thoughts, and I purposefully glance over to the bookshelf where he gave me my first orgasm. He glances too, and I wonder if he’s remembering as well.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Zach brings his dark eyes back to mine. “Wanted to let you know Daisy called me last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What? Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Worried about you. Wanted to know if I’d seen you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I sigh. “Sorry about that.”")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("He props his hip on the desk, and I become hyperaware of his warmth and his boy-scented body wash. His eyes roam ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("over me in that way they do when he takes in my red curly hair, green eyes, and pale freckly face.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Her mom died. Be patient.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My mom died too. Why don’t people seem to remember this? This is what I want to say but instead reply, “Well, thanks for letting me know.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He gives me a gentle, seemingly sad smile, and I want to ask him if he’s doing okay but don’t. I’m not sure why. Maybe because then he’ll ask about me, and I really can’t handle his probing. Or maybe because deep down I suspect he’s not doing well, and I don’t want to add that guilt to everything else going on in my brain.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A few quiet seconds tick by, and he gives me a nod before heading off.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If I could change schools, I would. I’m sick of the looks, the gossip, the hushed tones. This whole thing should’ve blown over by now, but it hasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’m Lane, niece to the Decapitator and daughter to the FBI director who lost her life saving my friend Zach. Or at least that’s what everyone believes.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("I am my mother’s daughter. I am a killer.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("That’s what I really am, and the reminder has something twitching inside me. I need to figure things out. "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("Soon")]), _vm._v(". Or that twitch is going to spiral violently out of control.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Yet I had my chance last night with Jacks and didn’t take it. ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("It’s been three—long—months since I’ve experienced that kick in my heart, that swell in my veins. Three months since I killed my mother.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("Though I’m not completely ready to admit it, in a crevice of my brain the thought sits there. Circling. Warming. A "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("kill")]), _vm._v(" is what I need to get myself back on track. But with a premeditated kill I will cross the line I’ve been teetering on. Once I step over that line, it can’t be undone.")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9495d9a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch02.vue
// module id = 66
// module chunks = 0